import { createFileRoute } from "@tanstack/react-router";
import { apiQuery, useApiSuspenseQuery } from "@/client/lib/api";
import { ensurePage, pageHead } from "@/client/lib/page";
import { ProntuarioPrintClient } from "@/client/modules/pacientes/detalhe/exportar/prontuario-print-client";

/** Exportação do prontuário para impressão/PDF (LGPD art. 18). */
export const Route = createFileRoute("/app/pacientes/$id/exportar")({
  loader: ({ context, params }) =>
    ensurePage(context.queryClient, apiQuery("pacientes", "exportPage", { id: params.id })),
  head: () => pageHead("Exportar prontuário"),
  // Exportar fica na auditoria a cada carga: não refazer em segundo plano.
  staleTime: Number.POSITIVE_INFINITY,
  component: ExportarProntuarioPage,
});

function ExportarProntuarioPage() {
  const { id } = Route.useParams();
  const { data } = useApiSuspenseQuery("pacientes", "exportPage", { id });
  return <ProntuarioPrintClient {...data} />;
}
